module.exports = __webpack_public_path__ + "static/img/huohuohuo.38ddec6f.png";